import { render } from "./NextBtn.vue?vue&type=template&id=64d64430"
import script from "./NextBtn.vue?vue&type=script&lang=js"
export * from "./NextBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__